let loaders = 0;
let restore: (() => void) | undefined;

export function acquirePageLoadingLock() {
  if (typeof document === "undefined" || !document.body) return () => {};
  if (loaders++ === 0) {
    const body = document.body;
    const overflow = body.style.getPropertyValue("overflow");
    const priority = body.style.getPropertyPriority("overflow");
    const root = document.getElementById("root");
    const inert = root?.getAttribute("inert");
    body.style.setProperty("overflow", "hidden", "important");
    root?.setAttribute("inert", "");
    restore = () => {
      if (overflow) body.style.setProperty("overflow", overflow, priority);
      else body.style.removeProperty("overflow");
      if (inert == null) root?.removeAttribute("inert");
      else root?.setAttribute("inert", inert);
    };
  }
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--loaders === 0) {
      restore?.();
      restore = undefined;
    }
  };
}
